import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-test-id": "product_list_component" }

import { ref, onMounted } from 'vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { getFormInput } from '@/utils/form-input-helper';
import ProductCardList from '@/components/ProductCardList/ProductCardList.vue';
import { useAccountStore } from '@/store';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import ModalDialog from '@/components/ModalDialog/ModalDialog.vue';
import { OK } from '@/constants/general-words.const';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountOverview',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const props = __props;
const accountStore = useAccountStore();
const productCard = ref(getFormInput(props.content, 'ProductCard'));
const registerModal = getFormInput(props.content, 'RegisterModal');
const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;
const route = useRoute();
const showRegisterPopup = ref(false);

onMounted(async () => {
  if (route?.query?.pop == 'reg') {
    showRegisterPopup.value = true;
    window.history.replaceState(null, '', window.location.pathname); // remove query to avoid showup again on refresh
  }

  pushAnalytics();

  const portfolio = accountStore.identityDetails?.portfolio;
  const anyInsurance = !!portfolio?.insurancePolicies?.length;
  const anyAssistance = !!portfolio?.assistanceProducts?.length;
  const anyBank = !!portfolio?.bankingProducts?.length;

  // ONLY show cross sell if there is no product
  if ((anyInsurance || anyAssistance || anyBank) && productCard.value.fields) {
    productCard.value && (productCard.value.crossSellPromo = []);
    productCard.value?.fields && (productCard.value.fields.crossSellPromo = []);
  }
});

const pushAnalytics = async () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);
  pageAnalytics.pushAnalytics();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FormStepInputs, {
      step: {
      stepName: _ctx.name,
      formInputs: _ctx.content,
    }
    }, {
      ProductCard: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ProductCardList, {
            fields: productCard.value,
            portfolio: _unref(accountStore).identityDetails?.portfolio
          }, null, 8, ["fields", "portfolio"])
        ])
      ]),
      _: 1
    }, 8, ["step"]),
    (_unref(registerModal)?.label)
      ? (_openBlock(), _createBlock(ModalDialog, {
          key: 0,
          modelValue: showRegisterPopup.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showRegisterPopup).value = $event)),
          closeOnEsc: true,
          showXCloseButton: true,
          size: "md"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_unref(RichText), {
                field: _unref(registerModal).label
              }, null, 8, ["field"]),
              _createElementVNode("button", {
                class: "btn btn-primary btn-md w-full",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showRegisterPopup.value = false))
              }, _toDisplayString(_unref(OK)), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})